const isSupportPatient = ({ id }) => id === 'pat-00000000000000000000000000000000';

export default isSupportPatient;
